export * from '@primeuix/themes/material/iftalabel';
export { default } from '@primeuix/themes/material/iftalabel';
